import { formatNumberBasedOnUser } from "utils/namesManipulation";

import type { EnergyAnalysisCategoryTotal } from "../model/types";

import { buildEnergyAnalysisAxisMax } from "./chartStyle";

export const buildCategoryBarOption = (
  categoryTotals: EnergyAnalysisCategoryTotal[],
  horizontal: boolean,
  snapshotValueMax?: number
) => {
  const range = snapshotValueMax === undefined ? undefined : buildEnergyAnalysisAxisMax(snapshotValueMax);
  const categoryAxis = {
    axisLabel: {
      interval: 0,
      rotate: horizontal ? 0 : 30,
    },
    boundaryGap: true,
    data: categoryTotals.map((item) => item.label),
    type: "category",
  };
  const valueAxis = {
    axisLabel: {
      formatter: (value: number) => formatNumberBasedOnUser(value, 2),
    },
    interval: range?.interval,
    max: range?.max,
    scale: false,
    type: "value",
  };
  return {
    dataZoom: [],
    legend: { show: false },
    series: [
      {
        barMaxWidth: 42,
        data: categoryTotals.map((item) => ({
          itemStyle: { color: item.color },
          value: item.value,
        })),
        tooltip: {
          valueFormatter: (value: number) => formatNumberBasedOnUser(value, 2),
        },
        type: "bar",
      },
    ],
    tooltip: {
      trigger: "axis",
    },
    xAxis: [horizontal ? valueAxis : categoryAxis],
    yAxis: [horizontal ? categoryAxis : valueAxis],
  };
};
